import gql from "graphql-tag";

export default gql`
mutation DeleteHoliday($deleteHolidayId: Int!) {
    deleteHoliday(id: $deleteHolidayId)
  }   
` 